import React from 'react';
import { useState } from 'react';
import About from './About';
import Banner from './Banner';
import Blogs from './Bolgs';
import Contact from './Contact';
import Footer from './Footer';
import Header from './Header';
import MyProjects from './MyProjects';
import Services from './Services';
import Skills from './Skills';

const Home = () => {
    const [blogs, setBlogs] = useState(false)
    return (
        <div>
             <Header setBlogs={setBlogs}></Header>
            <div className='lg:px-20'>
                <Banner></Banner>
                <About> </About>
                <Services></Services>
                <Skills></Skills>
                <MyProjects></MyProjects>
                {
                    blogs&&<Blogs></Blogs>
                }
            </div>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default Home;